import { history, NavigationPath } from "..";

export const selectedItem = () => {
  let selected = history.location.pathname;

  if (
    selected.includes(NavigationPath.ADD_USER_ROUTE) ||
    selected.startsWith(`${NavigationPath.EDIT_USER_ROUTE.split(":")[0]}`)
  ) {
    selected = NavigationPath.USERS_ROUTE;
  } else if (
    selected.includes(NavigationPath.ADD_OFFER_REQUEST_ROUTE) ||
    selected.startsWith(`${NavigationPath.EDIT_OFFER_REQUEST_ROUTE.split(":")[0]}`)
  ) {
    selected = NavigationPath.OFFER_REQUESTS_ROUTE;
  } else if (
    selected.includes(NavigationPath.ADD_INSURANCE_ROUTE) ||
    selected.startsWith(`${NavigationPath.EDIT_INSURANCE_ROUTE.split(":")[0]}`)
  ) {
    selected = NavigationPath.INSURANCE_ROUTE;
  } else if (
    selected.startsWith(`${NavigationPath.SINGLE_RESPONSE_ROUTE.split(":")[0]}`) ||
    selected.startsWith(`${NavigationPath.SINGLE_OFFER_RESPONSES_ROUTE.split(":")[0]}`)
  ) {
    selected = NavigationPath.OFFER_RESPONSES_ROUTE;
  } 
  return selected;
};
